// extracted by mini-css-extract-plugin
export default {"row":"LegalForm_row__KUZ8k","radioUseForReports":"LegalForm_radioUseForReports__3+cZ4","placeHolderShimmer":"LegalForm_placeHolderShimmer__nMNEE"};